import _extends from "@babel/runtime-corejs2/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
import _slicedToArray from "@babel/runtime-corejs2/helpers/slicedToArray";
var _excluded = ["as", "children", "onClick"],
  _excluded2 = ["as", "children"];
/* eslint-disable no-use-before-define */import * as React from 'react';
import { createContext, composeEventHandlers } from '../../utils';
import { useDisclosure } from './useDisclosure';
var _createContext =
  // $FlowFixMe[signature-verification-failure]
  createContext('Disclosure'),
  _createContext2 = _slicedToArray(_createContext, 2),
  DisclosureProvider = _createContext2[0],
  useDisclosureContext = _createContext2[1];
function Root(_ref) {
  var id = _ref.id,
    openProp = _ref.open,
    defaultOpen = _ref.defaultOpen,
    disabled = _ref.disabled,
    onOpenChange = _ref.onOpenChange,
    children = _ref.children;
  var _useDisclosure = useDisclosure({
      id: id,
      open: openProp,
      defaultOpen: defaultOpen,
      onOpenChange: onOpenChange
    }),
    open = _useDisclosure.open,
    contentId = _useDisclosure.contentId,
    toggle = _useDisclosure.toggle;
  return /*#__PURE__*/React.createElement(DisclosureProvider, {
    contentId: contentId,
    open: open,
    disabled: disabled,
    toggle: toggle
  }, children);
}
function Trigger(_ref2) {
  var _ref2$as = _ref2.as,
    Comp = _ref2$as === void 0 ? 'button' : _ref2$as,
    children = _ref2.children,
    onClick = _ref2.onClick,
    extraProps = _objectWithoutProperties(_ref2, _excluded);
  var _useDisclosureContext = useDisclosureContext('DisclosureTrigger'),
    contentId = _useDisclosureContext.contentId,
    open = _useDisclosureContext.open,
    disabled = _useDisclosureContext.disabled,
    toggle = _useDisclosureContext.toggle;
  return /*#__PURE__*/React.createElement(Comp, _extends({
    type: "button",
    disabled: disabled,
    "aria-expanded": open,
    "aria-controls": contentId,
    "data-state": getState(open),
    onClick: composeEventHandlers(onClick, toggle)
  }, extraProps), children);
}
function Content(_ref3) {
  var _ref3$as = _ref3.as,
    Comp = _ref3$as === void 0 ? 'div' : _ref3$as,
    children = _ref3.children,
    extraProps = _objectWithoutProperties(_ref3, _excluded2);
  var _useDisclosureContext2 = useDisclosureContext('DisclosureContent'),
    open = _useDisclosureContext2.open,
    contentId = _useDisclosureContext2.contentId,
    disabled = _useDisclosureContext2.disabled;
  return /*#__PURE__*/React.createElement(Comp, _extends({
    id: contentId,
    hidden: !open,
    "data-state": getState(open),
    "data-disabled": disabled ? '' : undefined
  }, extraProps), children);
}
function getState(open) {
  return open ? 'open' : 'closed';
}
Root.displayName = 'Disclosure';
Trigger.displayName = 'DisclosureTrigger';
Content.displayName = 'DisclosureContent';
export { Root as Disclosure, Trigger as DisclosureTrigger, Content as DisclosureContent };